// German copy in one place so Janine & Michi can review and tweak the wording
// without hunting through components. Short labels stay inline in JSX (same
// convention as the weltreise project). Keep sentences short and plain.

export const WELCOME = {
	title: 'Willkommen!',
	body: [
		'Hier sammeln wir alle Fotos und Videos von unserer Hochzeit.',
		'Schau dich um und lade herunter, was dir gefällt.',
		'Und ganz wichtig: Teile deine eigenen Fotos und Videos mit uns!',
	],
	ctaUpload: 'Meine Fotos hochladen',
	ctaBrowse: 'Erst mal umschauen',
};

// Church-only thank-you card: these guests see the photographer's gallery and
// nothing else, so there is no upload pitch.
export const WELCOME_LIMITED = {
	title: 'Willkommen!',
	body: [
		'Schön, dass du da bist!',
		'Hier findest du unseren Gruß aus den Flitterwochen – du kannst ihn dir jederzeit wieder ansehen.',
	],
	cta: 'Alles klar',
};

// Video greeting that opens after every thank-you card scan. The clip lives in its
// own gallery (`category`), so guests who closed the popup find it on the home page.
export const GREETING = {
	category: 'flitterwochen',
	title: 'Gruß aus unseren Flitterwochen',
	hint: 'Tippe auf das Video, um unsere Grußbotschaft aus den Flitterwochen anzusehen.',
	play: 'Video abspielen',
	reopen: 'Videogruß',
	fullscreen: 'Im Vollbild ansehen',
	close: 'Schließen',
};

export const FORBIDDEN = {
	title: 'Ups!',
	text: 'Diese Seite ist für dich leider nicht freigegeben.',
	button: 'Zur Startseite',
};

export const LOGIN = {
	sub: 'Janine & Michi · 11. Juli 2026',
	placeholder: 'Passwort',
	submit: 'Anmelden',
	error: 'Das Passwort stimmt nicht.',
	rateLimited: 'Zu viele Versuche. Bitte warte eine Minute.',
};

export const UPLOAD = {
	title: 'Eure Fotos & Videos',
	zoneTitle: 'Fotos & Videos hochladen',
	zoneSubTouch: 'Du kannst viele auf einmal auswählen.',
	zoneSubMouse: 'Zieh deine Dateien hierher – oder wähle sie aus.',
	pick: 'Fotos & Videos auswählen',
	hashing: (done, total) => `Dateien werden geprüft … ${done}/${total}`,
	uploading: (done, total) => `Wird hochgeladen … ${done}/${total}`,
	// A single big video holds the aggregate bar still for minutes — give it its own
	// percentage so the guest can see it is actually moving.
	uploadingVideo: (done, total, pct) => `Video wird hochgeladen … ${done}/${total} · ${pct} %`,
	slowHint: 'Große Videos brauchen ein paar Minuten. Lass die Seite so lange geöffnet.',
	retrying: 'Verbindung unterbrochen – neuer Versuch …',
	leaveGuard: 'Der Upload läuft noch – Seite wirklich verlassen?',
	retryFailed: (n) => `${n} fehlgeschlagen – erneut versuchen`,
	tooLarge: (name, max) => `„${name}“ ist zu groß (maximal ${max}).`,
};

export function uploadSummary(uploaded, duplicates, failed, tooLarge = 0) {
	const parts = [];
	parts.push(uploaded === 1 ? '1 Datei erfolgreich hochgeladen.' : `${uploaded} Dateien erfolgreich hochgeladen.`);
	if (duplicates > 0) {
		parts.push(duplicates === 1 ? '1 Duplikat wurde übersprungen.' : `${duplicates} Duplikate wurden übersprungen.`);
	}
	if (tooLarge > 0) {
		parts.push(tooLarge === 1 ? '1 Datei war zu groß.' : `${tooLarge} Dateien waren zu groß.`);
	}
	if (failed > 0) {
		parts.push(failed === 1 ? '1 Datei konnte nicht hochgeladen werden.' : `${failed} Dateien konnten nicht hochgeladen werden.`);
	}
	return parts.join(' ');
}

export const CTA = {
	text: 'Hast du Fotos von der Hochzeit?',
	button: 'Jetzt hochladen',
};

export const HOME = {
	soonTitle: 'Bald verfügbar',
	empty: 'Hier gibt es bald etwas zu sehen.',
	// Admin-only marker on galleries guests can't see yet.
	hidden: 'Nicht freigegeben',
	uploadButton: 'Fotos & Videos hochladen',
	uploadCount: (n) => (n === 1 ? 'Schon 1 Foto oder Video von euch – danke!' : `Schon ${n} Fotos & Videos von euch – danke!`),
};

export const GALLERY = {
	empty: 'Hier gibt es noch nichts zu sehen.',
	emptyUpload: 'Noch keine Uploads. Mach den Anfang!',
	comingSoonBadge: 'Bald verfügbar',
	processing: 'Wird verarbeitet …',
	select: 'Auswählen',
	selectDone: 'Fertig',
	selectAll: 'Alle auswählen',
	downloadAll: 'Alles herunterladen',
	items: (n) => (n === 1 ? '1 Foto oder Video' : `${n} Fotos & Videos`),
	selected: (n) => (n === 1 ? '1 ausgewählt' : `${n} ausgewählt`),
	deleteOwn: 'Eigenen Upload löschen',
	deleteConfirm: 'Deinen Upload wirklich löschen?',
	deleted: 'Dein Upload wurde gelöscht.',
};

export const ERRORS = {
	diskFull: 'Kein Speicherplatz mehr frei. Bitte sagt Janine & Michi Bescheid.',
	network: 'Keine Verbindung. Bitte versuche es noch einmal.',
	generic: 'Das hat nicht geklappt. Bitte versuche es noch einmal.',
};

export function fmtBytes(n) {
	if (n == null) return '';
	if (n >= 1024 * 1024 * 1024) return `${(n / 1024 / 1024 / 1024).toFixed(1).replace('.', ',')} GB`;
	if (n >= 1024 * 1024) return `${Math.round(n / 1024 / 1024)} MB`;
	return `${Math.max(1, Math.round(n / 1024))} KB`;
}
